export default [
  {
    path: "/pri0d24932b28630d1cf28263655b7881c4a116bfe5f850a43cas/:er?",
    name: "baice25.photoAlbum",
    component: () => import("@/views/baice/twf/photoalbum/index.vue"),
    meta: {
      title: "Print 2025 BAICE PhotoAlbum",
      authRequired: true,
      acc: ["y28040"],
    },
  },
  {
    path: "/pri0d24932b2863bfe5f850a43cas",
    name: "baice25.photoAlbums",
    component: () => import("@/views/baice/twf/photoalbum/list.vue"),
    meta: {
      title: "2025 BAICE PhotoAlbum",
      authRequired: true,
      acc: ["y33611"],
    },
  },
];
